import { ElementAttribute } from "../dom-tools/ElementAttribute";
import { ElementType } from "../dom-tools/ElementType";
import { Lexer } from "../text/lexer/Lexer";
import { LexerMatcher } from "../text/lexer/LexerMatcher";
import { LexerMatcherLibrary } from "../text/lexer/LexerMatcherLibrary";
import { RegExpUtility } from "../text/RegExpUtility";

export class SocialMediaPost
{
  static readonly type = new ElementType( "social--media--post" );
  static readonly token = new ElementType( "social--media--token" );
  static readonly tokenType = new ElementAttribute( "type" );

  static applyOnDocument()
  {
    SocialMediaPost.type.forAllInDoc( e => this.applyOnElement( e ) );
  }

  static applyOnElement( e:Element )
  {
    var textContent = RegExpUtility.removeLeadingSpace( e.textContent );

    let lexer = new Lexer();

    lexer.addMatcher( LexerMatcherLibrary.URL );
    lexer.addMatcher( LexerMatcherLibrary.HASH_TAG );    
    
    lexer.addMatcher( LexerMatcherLibrary.BREAK_MATCHER );
    lexer.addMatcher( LexerMatcherLibrary.ANY_SYMBOL_MATCHER );
    
    let compressTypes = new Set<string>();
    compressTypes.add( LexerMatcherLibrary.ANY_SYMBOL_MATCHER.type );

    var tokens = lexer.lexToList( textContent );
    tokens = lexer.compress( tokens, compressTypes );

    console.log( "social media post", e.textContent, tokens );
    
    var hasError = tokens.find( t => t.isError );

    e.innerHTML = "";

    if ( hasError )
    {
      e.appendChild( document.createTextNode( textContent ) );
      return;
    }

    tokens.forEach(
      ( t )=>
      {
        let type = t.type;

        if ( type === "default" )
        {
          return;
        }

        let match = textContent.substring( t.offset, t.end );

        let token = SocialMediaPost.token.create( match );  

        SocialMediaPost.tokenType.to( token, type );        

        if ( type === LexerMatcherLibrary.URL.type )
        {
          let anchor = ElementType.anchor.create( token );
          ElementAttribute.href.to( anchor, match );

          e.appendChild( anchor );
        }
        else
        {
          e.appendChild( token );
        }

       
      }
    );
  }
}